import { ReactNode, useCallback, useState } from 'react';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Tooltip } from '@cbhq/cds-web/overlays';
import { Modal } from '@cbhq/cds-web/overlays/modal/Modal';
import { ModalHeader } from '@cbhq/cds-web/overlays/modal/ModalHeader';
import { ModalBody } from '@cbhq/cds-web/overlays/modal/ModalBody';
import { VStack } from '@cbhq/cds-web/layout';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';

export type SettingsProps = {
  title: string;
  children: ReactNode;
  testID?: string;
};

export function SettingsButton({ title, children, testID }: SettingsProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModalOn = useCallback(() => setIsModalVisible(true), []);
  const toggleModalOff = useCallback(() => setIsModalVisible(false), []);
  const { isPhone, isPhoneLandscape } = useBreakpoints();

  const handleModalDidClose = useCallback(() => {}, []);

  return (
    <>
      <Tooltip content={`Edit ${title.toLowerCase()}`} placement="left">
        <IconButton
          as="button"
          name="gear"
          compact
          onClick={toggleModalOn}
          variant="secondary"
          testID={`${testID}-open-modal-button`}
          active
        />
      </Tooltip>
      <Modal
        width={isPhone || isPhoneLandscape ? undefined : 422}
        visible={isModalVisible}
        onRequestClose={toggleModalOff}
        onDidClose={handleModalDidClose}
        testID={`${testID}-modal`}
      >
        <ModalHeader title={title} />
        <ModalBody>
          <VStack gap={4}>{children}</VStack>
        </ModalBody>
      </Modal>
    </>
  );
}
